// import css from './catalog.module.css'
// import img1 from '../../img/manuscript.png'
// import img2 from '../../img/saleNewOne.png'
// import img3 from '../../img/pic2.png'

// export default function FirstBlockMan() {

//     return(
//         <div className={css.wrapManus}>
//          <div className={css.wrapFirstManus}>
//             <div className={css.someTextWramMan}>
//                 <h3 className={css.manuscriptH3}>Рукописи</h3>
//                 <p className={css.manuscriptP}>читай першим! </p>
//             </div>
//             <img src={img1} className={css.firstImg}/>
//             <img src={img2} className={css.secondImg}/>
//             <img src={img3} className={css.threImg}/>
//          </div>
//         </div>
//     )
// }
import { useRef } from "react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import css from "./catalog.module.css";

function getYearLabel(year) {
  const value = Number(year);

  if (value === 1) return "1 рік";
  if (value >= 2 && value <= 4) return `${value} роки`;

  return `${value} років`;
}

function getMasterId(master) {
  return String(master?.uid || master?.id || "");
}

function getMasterInitials(name) {
  return String(name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export default function FirstBlockMan({
  yearOptions = [],
  selectedYear = "",
  onYearChange,
  masters = [],
  hasConfiguredMasters = false,
  selectedMasterId = "",
  onMasterSelect,
  masterSearch = "",
  onMasterSearchChange,
}) {
  const mastersRef = useRef(null);

  const scrollMasters = (direction) => {
    mastersRef.current?.scrollBy({
      left: direction * 260,
      behavior: "smooth",
    });
  };

  return (
    <div className={css.wrapManus}>
      <div className={css.wrapFirstManus}>
        <div className={css.someTextWramMan}>
          <h3 className={css.manuscriptH3}>Рукописи</h3>
          <p className={css.manuscriptP}>читай першим!</p>

          <select
            className={css.manuscriptYearSelect}
            value={selectedYear}
            onChange={(event) => onYearChange(event.target.value)}
            aria-label="Вік читача"
          >
            <option value="">Усі роки</option>

            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {getYearLabel(year)}
              </option>
            ))}
          </select>
        </div>

        <div className={css.mastersExplorer}>
          <div className={css.mastersHeader}>
            <h2 className={css.mastersTitle}>Майстри рукописів</h2>

            <div className={css.mastersTools}>
              <label className={css.masterSearch}>
                <FiSearch aria-hidden="true" />
                <span className={css.visuallyHidden}>Пошук майстра</span>
                <input
                  type="search"
                  value={masterSearch}
                  onChange={(event) =>
                    onMasterSearchChange(event.target.value)
                  }
                  placeholder="Знайти майстра"
                />
              </label>

              {masters.length > 1 && (
                <div className={css.masterArrows}>
                  <button
                    type="button"
                    className={css.masterArrow}
                    onClick={() => scrollMasters(-1)}
                    aria-label="Попередні майстри"
                    title="Попередні майстри"
                  >
                    <FiChevronLeft aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    className={css.masterArrow}
                    onClick={() => scrollMasters(1)}
                    aria-label="Наступні майстри"
                    title="Наступні майстри"
                  >
                    <FiChevronRight aria-hidden="true" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className={css.mastersList} ref={mastersRef}>
            {masters.map((master) => {
              const masterId = getMasterId(master);
              const isSelected = masterId === selectedMasterId;

              return (
                <button
                  type="button"
                  key={masterId}
                  className={`${css.masterCard} ${
                    isSelected ? css.masterCardActive : ""
                  }`}
                  onClick={() => onMasterSelect(masterId)}
                  aria-pressed={isSelected}
                >
                  {master.foto ? (
                    <img
                      src={master.foto}
                      className={css.masterPhoto}
                      alt=""
                    />
                  ) : (
                    <span className={css.masterPhotoFallback}>
                      {getMasterInitials(master.name)}
                    </span>
                  )}
                  <span className={css.masterName}>{master.name}</span>
                </button>
              );
            })}

            {masters.length === 0 && (
              <p className={css.mastersEmpty}>
                {masterSearch.trim() && hasConfiguredMasters
                  ? "За цим запитом майстрів не знайдено."
                  : "У майстрів ще немає призначених рукописів."}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
